// 中文
export default {
  readMore: '阅读更多',
  startForFree: '立即免费试用',
  required: '{name}不能为空',
  tryForFree: '免费体验',
  CarouselTitle: '为全球企业赋能，助力企业业务稳健发展。',
  publicConsultation: {
    title1: '云盾 ',
    title2: 'AI SaaS',
    title3: ' 咨询&体验',
    item1: 'AI Ads',
    item2: 'EKYC',
    item3: 'Luna AI机器人',
    item4: '反欺诈服务',
    item5: '信用分服务',
    productGroup: '您想咨询的产品是',
    submitTip: '提交表单表示：您同意云盾及其授权的合作伙伴通过您填写的联系方式联系您，且数据仅用于与您沟通。',
    form: {
      product: '产品',
      companyName: '公司名称',
      contactPersonName: '联系人姓名',
      contactPersonPhone: '联系人手机',
      descriptionOfNeeds: '需求描述'
    }
  },
  home: {
    title1: 'AI赋能',
    title2: '新时代数字金融',
    EKYC: {
      title1: '拥有视觉反欺诈能力的',
      title2: 'EKYC服务',
      ProductTitle1: '证件识别',
      ProductSubTitle1: '精准识别10余个主流国家百余种证件资料, 快速、丝滑、高效完整证件录入。',
      ProductTitle2: '活体检测',
      ProductSubTitle2: '快速验证用户是否为真人操作，有效防止多种欺诈攻击。',
      ProductTitle3: '高级人脸检测',
      ProductSubTitle3: '先进的人脸视觉在库搜索、比对能力，探查用户更多隐藏信息。',
      ProductTitle4: 'EKYC欺诈检测',
      ProductSubTitle4: '精准识别十余种证件欺诈、十余种活体欺诈行为，保护您的业务远离欺诈风险。'
    },
    creditScore: {
      title1: '基于海量大数据的精准',
      title2: '信用分模型,',
      title3: '护航业务稳定攀升',
      ProductTitle1: '黑名单',
      ProductSubTitle1: '海量数据基础, 覆盖全球10余个数字金融主流国家, 有效屏蔽劣质用户, 快速提升业务表现。',
      ProductTitle2: '前置审核',
      ProductSubTitle2: '基于认证三要素快速初审用户信用，帮助业务节省在后续流程中无效调用三方的成本支出。',
      ProductTitle3: '综合审核',
      ProductSubTitle3: '基于数万个特征点建立多维模型，有效识别风险，精准计算用户信用。',
      ProductTitle4: '额度测算',
      ProductSubTitle4: '科学测算用户的有效信用额度，降低风险的同时快速提高件均提升业务盈利水平。'
    },
    antiFraud: {
      title1: '持续迭代保持行业最前沿的',
      title2: '反欺诈能力, ',
      title3: '快人一步',
      ProductTitle1: 'EKYC欺诈检测',
      ProductTitle2: '移动设备反欺诈',
      ProductTitle3: 'IP反欺诈',
      ProductTitle4: '银行卡反欺诈',
      standardProduct: '地理位置反欺诈'
    },
    lunaAI: {
      title1: 'LUNA AI语音外呼机器人,',
      title2: '新时代高效触达客户的首选方式',
      repaymentAITitle: '还款提醒 AI语音机器人',
      repaymentAIText: '依托云盾智能云联络中心服务, 与深度学习高绩效还款策略话术的AI机器人, 为您提供一站式的智能语音外呼方案, 提高还款率。',
      customerServiceAITitle: '客服 AI语音机器人',
      customerServiceAIText: '依托您的企业知识库与业务流程，量身定制企业独有的 AI 客服系统，为您开启全时在线的智能服务新纪元。',
      marketingAITitle: '营销 AI语音机器人',
      marketingAIText: 'AI 营销外呼坐席，赋能企业客户实现用户的全生命周期价值管理赋能客户全生命周期智慧营销。',
      multilingualAITitle: '多国语言 AI语音机器人',
      multilingualAIText: '即刻拥有您专属的本地化类人的语音外呼对话AI员工。',
      LLMVoiceTitle: '大模型语音对话专家',
      LLMVoiceText: '基于LLM精准识别用户意图, 并基于优质语聊话术库实时生成聊天语音 建立您业务的高级沟通坐席群，高效转化用户。',
      intelligentContactTitle: '智能联络中心通信平台',
      intelligentContactText: '资源丰富的通信平台，建立您触达用户的稳定可靠渠道。'
    },
    overseasMarket: {
      title1: '专业海外投放',
      title2: '运营团队, 为您带来10倍投放提速, 10倍流量增长。',
      applicationMarketTitle: '应用市场智慧装修',
      applicationMarketText: '专业设计师与运营团队为您的App定制应用商店装修设计, 从上架视频到图文评论运营, 承接流量提高下载转化。',
      investmentFlowTitle: '海外市场智慧投流',
      investmentFlowText: '以强大的多媒体AIGC生成能力, 极速产出海量高品质的投流视频与图文素材。极大降低广告内容制作成本, 开启高质高量获取海外流量新时代。',
      majorTitle: '专业海外投流服务',
      majorText: '海外专业投流团队深耕Facebook、TikTok、Google等全球主流平台, 成功帮助近百家企业获得海量用户, 大幅度提高投流ROI。'
    },
    solution: {
      title: '与我们一起，实现业务盈利增长',
      item1Title: '线上贷款全链路解决方案',
      item1Text: '从咨询、商业模式建立、定制化开发和部署，到运营指导和运营分析，最终到运营策略和代码的完整转移，实现全面的业务解决方案。',
      item2Title: '海外市场获客全链路解决方案',
      item2Text: '从应用商店装修，到投流多媒体素材制作，最终到专业投流团队为您服务获得海量获客。'
    },
    ISOAuthentication: {
      title: '全球认证',
      item1: '云盾已通过ISO27001国际权威认证, 具备覆盖信息安全全流程的风险管理体系, 展现了从数据保护到合规运营的全面能力。我们以全球领先的标准, 保障您的隐私与商业机密安全, 助力您的业务轻松符合GDPR等国际严格法规要求。',
      subTitle: '计算机软件著作权登记证书',
      item2: '云盾已取得近20项计算机软件著作权登记证书, 实现覆盖核心风控算法、大数据计算、CV视图识别等核心领域的自主知识产权建设与保护。这些技术成果为客户的数字化升级提供强大支持, 保障业务系统持续安全稳定运行。',
      certificate2: '计算机软件著作权登记证书'
    },
    businessMap: {
      title: '我们服务的国家'
    },
    startFor: {
      title: '体验云盾SaaS平台',
      subTitle: '为您的业务加速'
    }
  },
  EKYC: {
    slogan1: '拥有反欺诈视觉能力的',
    slogan2: 'EKYC',
    subSlogan: '给客户更丝滑的认证体验, 给业务更可靠的EKYC认证数据。',
    trialGuidance: '体验有反欺诈能力的丝滑EKYC',
    IDDetect: {
      title: '证件识别',
      introduction: '精准识别10余个主流国家百余种证件资料, 快速、丝滑、高效完整证件录入。',
      introductionItem1: '成熟的客户端SDK解决方案, 快速集成;',
      introductionItem2: '极致交互体验，更高客户转化率;',
      introductionItem3: '支持各国全证件类型, 识别率高达99.9%'
    },
    livenessDetect: {
      title: '活体检测',
      introduction: '快速验证用户是否为真人操作，有效防止多种欺诈攻击。',
      introductionItem1Title: '用户友好',
      introductionItem1Text: '极致交互体验，用户丝滑完成认证',
      introductionItem2Title: '快速集成',
      introductionItem2Text: '完备的全流程认证界面，零前端开发。',
      introductionItem3Title: '多端支持',
      introductionItem3Text: 'iOS SDK、 Android SDK、web H5, 全方位支持您的多形态产品'
    },
    faceDetect: {
      title: '高级人脸检测',
      introduction: '先进的人脸视觉在库搜索、比对能力，探查用户更多隐藏信息。',
      introductionItem1Title: '人证对比能力',
      introductionItem1Text: '基于人脸识别与比对技术，将用户自拍与其证件照进行匹配核验，确认申请人身份一致性',
      introductionItem2Title: '人脸在库查询能力',
      introductionItem2Text: '检索用户人脸的历史在库信息是否存在(历史ID信息、申请、还款状态)'
    },
    fraudDetect: {
      title: 'EKYC欺诈检测',
      introduction: '精准识别十余种证件欺诈、十余种活体欺诈行为，保护您的业务远离欺诈风险。',
      exampleItem1: '屏幕人脸翻拍检测',
      exampleItem2: '脸部涂抹检测',
      exampleItem3: '脸部夸张表情检测',
      exampleItem4: '背景图AI替换检测',
      exampleItem5: 'AIGC人脸检测',
      tip: '以上为已脱敏的欺诈示例图片'
    },
    feature: {
      featureItem1Label: '已经被调用多少次',
      featureItem1Value: '200,000,000+',
      featureItem2Label: '服务涵盖国家数',
      featureItem2Value: '8+',
      featureItem3Label: 'OCR支持证件类型',
      featureItem3Value: '50+'
    }
  },
  creditScore: {
    slogan1: '助力业务稳定攀升的',
    slogan2: '云盾信用分',
    subSlogan: '依托海量数据，运用多维风控模型精准洞察信用，助力业务在降低风险的同时快速提高件均提升业务盈利水平。',
    trialGuidance: '和众多先进企业一起用风控大数据模型提高业绩',
    blacklist: {
      title: '黑名单',
      introduction: '海量数据基础, 覆盖全球10余个数字金融主流国家, 有效屏蔽劣质用户, 快速提升业务表现。'
    },
    preAudit: {
      title: '前置审核',
      introduction: '基于认证三要素快速初审用户信用，帮助业务节省在后续流程中无效调用三方的成本支出'
    },
    audit: {
      title: '综合审核',
      introduction: '基于 20000 + 特征点的多维模型，有效识别风险，精准计算用户信用。'
    },
    amountLimit: {
      title: '额度测算',
      introduction: '科学测算用户的有效信用额度，降低风险的同时快速提高件均提升业务盈利水平。'
    },
    feature: {
      featureItem1Label: '服务国家',
      featureItem1Value: '8+',
      featureItem2Label: '服务项目',
      featureItem2Value: '100+',
      featureItem3Label: '调用次数',
      featureItem3Value: '1.6亿次+',
      featureItem4Label: '放款金额',
      featureItem4Value: '50亿美金+',
      featureItem5Label: '模型迭代',
      featureItem5Value: '500+',
      featureItem6Label: '特征数量',
      featureItem6Value: '20w+'
    }
  },
  antiFraud: {
    slogan1: '快人一步的',
    slogan2: 'AI反欺诈',
    subSlogan: '持续迭代保持行业最前沿的反欺诈能力，快人一步。',
    trialGuidance: '接入云盾反欺诈保护您的业务',
    functionIntroduction: '面对市场中层出不穷的欺诈手段，云盾基于利用大数据技术，在用户录入信息与用户设备信息中，提取特征，全方位识别欺诈团伙的证件作弊、诈骗团队聚集刷单等行为，保护您的业务安全。',
    feature: {
      featureItem1Label: '调用量',
      featureItem1Value: '10,000,000+',
      featureItem2Label: '欺诈用户识别率',
      featureItem2Value: '95+%',
      featureItem3Label: '已识别欺诈用户',
      featureItem3Value: '1,000,000+',
      featureItem4Label: '已上线自研反欺诈模型',
      featureItem4Value: '20+'
    }
  },
  lunaAi: {
    slogan1: 'Luna AI语音机器人',
    subSlogan: 'AI语音外呼员工, 新时代高效触达客户的首选方式',
    subTag1: '对话式沟通提高转化',
    subTag2: '高拟人语音更亲和',
    subTag3: '高可靠通信平台',
    trialGuidance: '体验新时代的客户沟通方式',
    repaymentReminder: {
      title: '还款提醒 AI语音机器人',
      introduction: '依托云盾智能云联络中心服务, 与深度学习高绩效还款策略话术的AI机器人, 为您提供一站式的智能语音外呼方案, 提高还款率。',
      introductionItem1: '定制专属AI员工: 精准设定语言风格、语音音色、沟通语气。',
      introductionItem2: '适配多种还款提醒策略，深度契合不同客户还款阶段的提醒方式。',
      introductionItem3: '制定外呼综合策略，有效提升业务综合还款率，赋能还款管理智能化。'
    },
    customerService: {
      title: '客服 AI语音机器人',
      introduction: '依托您的企业知识库与业务流程，量身定制企业独有的 AI 客服系统，为您开启全时在线的智能服务新纪元。',
      introductionItem1Title: '全天候不间断服务',
      introductionItem1Text: '全年无休, 7x24 小时在线解答客户咨询，确保服务永不掉线。',
      introductionItem2Title: '智能学习进化',
      introductionItem2Text: '迅速掌握企业知识库，精准回应各类业务问题，持续提升服务效能。',
      introductionItem3Title: '贴心服务体验',
      introductionItem3Text: '以十足耐心应对每一次交互，为客户提供优质、高效、满意的服务。'
    },
    marketing: {
      title: '营销AI语音机器人',
      introduction: '即刻拥有您专属的本地化类人的语音外呼对话AI员工。',
      introductionItem1: '1v1 智能语音交互：精准洞察客户意图，精准把握营销契机，驱动客户转化。',
      introductionItem2: '全生命周期营销模板：涵盖引流、跟进、转化、复购全链路的自动化外呼机智与话术语库，重构业务增长新模式。',
      introductionItem3: '学习专家话术库：支持上传企业内部营销专家知识库，快速汲取顶级话术精华。'
    },
    multilingual: {
      title: '多国语言 AI语音机器人',
      introduction: '一分钟即可拥有您对专属的使用本国语言的高度拟人对话AI坐席员工。',
      introductionItem1Title: '高度拟人对话',
      introductionItem1Text: '沉淀丰富语言技术, 运用智能打断、语气承接等先进技术, 让AI员工在沟通中更智能、更贴近人类交流方式, 优化对话体验。音色丰富更像真人, 让用户亲切减少挂断。',
      introductionItem2Title: '极速创建',
      introductionItem2Text: '已积累多国AI语音机器人模板, 可立即上线使用。'
    },
    largeModel: {
      title: '大模型语音对话专家',
      introduction: '基于LLM快速学习优质语聊话术精准识别用户意图, 建立您业务的高级沟通坐席群, 高效转化用户。',
      introductionItem1Title: '精准识别用户意图',
      introductionItem1Text: '基于大语言模型，精准识别用户意图，为客户行为转化提供有力支持，显著提升业务成效。',
      introductionItem2Title: '专家话术智能生成',
      introductionItem2Text: '依托先进的大语言模型，汲取海量优质话术精髓，在“提醒还款”、“智能客服”、“营销推广”等方向，结合用户个性化信息与意图表达，即时生成针对性强、专业的沟通话术，全面优化客户沟通效果。'
    },
    contactCenter: {
      title: '智能联络中心通信平台',
      introduction: '资源丰富的通信平台，建立您触达用户稳定可靠的服务',
      introductionItem1Title: '资源丰富',
      introductionItem1Text: '集合海外丰富优质通信资源',
      introductionItem2Title: '平台稳定',
      introductionItem2Text: '通信交换接入平台，极具可靠性稳定性',
      introductionItem3Title: '省时省力',
      introductionItem3Text: '多国多网资源集成, API一站式接入'
    },
    feature: {
      featureItem1Title: '当日即可快速接入',
      featureItem1: '已完备多国语音机器人',
      featureItem2: '已有多个国家，还款计划意图识别与话术模板',
      featureItem3: '上传客服语料库快速完成客服知识库',
      featureItem2Title: '提高用户触达率',
      featureItem3Title: '提高还款率'
    }
  },
  aiAds: {
    slogan1: 'AI广告服务',
    slogan2: '获得海量海外流量',
    subSlogan: '与云盾广告团队一起, 为您加速获取海外市场流量: 10倍投放提速, 10倍流量增长',
    subTag1: '社交媒体投放',
    subTag2: '广告素材制作',
    subTag3: '应用市场流量',
    subTag4: '海外市场',
    trialGuidance: '立即获得海量流量服务',
    furnish: {
      title: '应用市场装修',
      introduction: '专业设计师与运营团队为您的App定制应用商店装修设计, 从上架视频到图文评论运营, 承接流量提高下载转化。',
      introductionItem1: 'App logo、App Store 上架图片、视频及适配配文(UI设计与AIGC)',
      introductionItem2: '专业团队1v1为您服务'
    },
    material: {
      title: '海外市场智慧投流素材制作',
      introduction: '以强大的多媒体AIGC生成能力, 极速产出海量高品质的投流视频与图文素材。极大降低广告内容制作成本, 开启高质高量获取海外流量新时代。',
      introductionItem1: 'AIGC数字人原创广告视频素材',
      introductionItem2: 'AIGC数字人换脸广告视频素材',
      introductionItem3: 'AIGC广告图文素材',
      introductionItem4: '支持多国语言'
    },
    feature: {
      featureItem1Label: '支持的广告素材语言',
      featureItem1Value: '8国',
      featureItem2Label: '应用市场下载转化率',
      featureItem2Value: '+50%',
      featureItem3Label: '投流ROI提高',
      featureItem3Value: '30%'
    }
  },
  company: {
    title: '云盾赋能全球金融企业',
    submitTitle: '利用自研的AI技术与金融科技, 赋能全球金融企业提升金融服务效率，为消费者带来更好的金融产品。',
    companyHistory: {
      title: '云盾数字金融AI解决方案',
      item2018OneActive: '奋钛（云盾）',
      item2018One: '成立, 主要从事贷款SaaS开发。',
      item2019OneActive: '云盾开曼和新加坡',
      item2019One: '于2019年5月成立。',
      item2019Two: '集团开始在印尼探索金融科技AI和',
      item2019TwoActive: '技术服务。',
      item2020OneActive: '云盾印尼',
      item2020One: '成立, 开始在印尼提供EKYC、信用洞察、数字借贷咨询服务。',
      item2021OneActive: '云盾香港',
      item2021One: '成立, 开始在墨西哥开展业务, 拓展产品线: AI广告。',
      item2021Two: '截至2021年底, 云盾为67家企业客户提供服务, API调用量超过',
      item2021TwoActive: '9000万次。',
      item2022OneActive: '云盾集团',
      item2022One: '在墨西哥和印尼市场不断优化产品, 企业客户不断增加, 保持业务可持续增长。2023年, API调用量达到当年2.7亿次。',
      item2022Two: '完成A轮融资。',
      item2024One: '在保持现有市场稳定增长的基础上, 云盾横向拓展到菲律宾等其他地区, 纵向推进AI聊天机器人等智能运营系统的开发。',
      item2024Two: '截至2024年12月, 云盾已为90多家企业客户提供服务, 金融交易额超过50亿美元, 连接近5000万终端用户。',
      item2024Three: '我们与产业链上的关键参与者合作，促进协作，创造共享价值。'
    }
  },
  solution: {
    slogan1: '携手合作伙伴共创价值，驱动业务长效增长',
    subSlogan: '依托全周期服务体系，构建涵盖商业模式顶层设计、定制化系统开发与部署、业务冷启动指导、运营策略优化及系统化技术转移的综合解决方案，实现业务全链路闭环赋能。',
    businessGrowth: {
      title: '价值增长与效能提升',
      subTitle: '基于成熟的行业实践经验，配备全周期服务跟踪体系，通过数据驱动的运营优化策略，确保合作方实现可量化的商业价值转化。'
    },
    consult: {
      title: '技术构建与知识迁移',
      subTitle: '完成全量技术资产移交的同时，系统性输出商业模型构建方法论、风险管理体系专项培训及实战运营沙盘演练，确保技术自主性与运营持续性双重保障。'
    },
    customization: {
      title: '智能部署与收益优化',
      subTitle1: '基于深度需求洞察的定制化系统架构设计；',
      subTitle2: '全流程精细化实施管理，通过动态风控建模与智能决策引擎，实现客户收益能效最大化。'
    }
  },
  el: {
    pleaseEnter: '请输入',
    submit: '提交'
  },
  publicNavigation: {
    navList: {
      item1: '首页',
      item2: '产品',
      item3: '解决方案',
      item4: '关于我们'
    },
    menuList: {
      item1Title: 'EKYC',
      item1Subtitle: '给客户更丝滑的认证体验, 给业务更可靠的EKYC认证数据。',
      item2Title: '云盾信用分',
      item2Subtitle: '依托海量数据，运用多维风控模型精准洞察信用，助力业务在降低风险的同时快速提高件均提升业务盈利水平。',
      item3Title: 'AI反欺诈',
      item3Subtitle: '持续迭代保持行业最前沿的反欺诈能力，快人一步。',
      item4Title: 'Luna AI语音机器人',
      item4Subtitle: 'AI语音外呼员工, 新时代高效触达客户的首选方式。',
      item5Title: 'AI广告服务',
      item5Subtitle: '与云盾广告团队一起, 为您加速获取海外市场流量: 10倍投放提速, 10倍流量增长'
    }
  },
  publicFooter: {
    products: '产品',
    product1: 'AI Ads',
    product2: 'EKYC',
    product3: 'Luna AI机器人',
    product4: '反欺诈服务',
    product5: '信用分服务',
    solutions: '解决方案',
    solutions1: '线上贷款全链路解决方案',
    solutions2: '海外市场获客全链路解决方案',
    company: '企业',
    company1: '关于我们',
    contactUs: '联系我们',
    contactUs1: '电话',
    contactUs2: '邮箱'
  }
}
